import { render, staticRenderFns } from "./JobStatusPanelAppointment.vue?vue&type=template&id=55c4d358"
import script from "./JobStatusPanelAppointment.vue?vue&type=script&lang=ts"
export * from "./JobStatusPanelAppointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports